enum DashboardPreferencesActionEnum {
  SET_PREFERENCES = 'SET_PREFERENCES',
  CLEAR_PREFERENCES = 'CLEAR_PREFERENCES',
}

export default DashboardPreferencesActionEnum;
